<template>
  <div>

    <div style="height: 40px;"></div>






    <div style="padding: 0px 10px;">
      <div style="display: flex;">
        <div>总数据<font style="color: red;font-weight: bold;">{{allcount}}</font>条
        </div>
        <button @click="showalldatas" style="margin: 0 3px;">显示全部</button>

      </div>

    </div>


    <van-dropdown-menu>
      <van-dropdown-item v-model="value1" :options="option1" />
      <van-dropdown-item v-model="value2" :options="option2" />
      <van-dropdown-item title="概览信息">
        <van-cell center v-for="(v,i) in gailaninfo" :title="v.name" :key="i">
          <template #right-icon>
            <van-switch size="24" :value="v.check" @input="writelocal(v)" active-color="#ee0a24" />
          </template>
        </van-cell>
      </van-dropdown-item>
    </van-dropdown-menu>

    <van-search v-model="value22" show-action :label="option1.find(item=>item.value==value1).text.substr(1)"
      :placeholder="'请输入'+option1.find(item=>item.value==value1).text.substr(1)"  @search="onSearch" :clearable="false">
      <template #action>
        <div @click="onSearch">查询</div>
      </template>
    </van-search>
    <!-- <div style="padding:0px 25px;" v-show="value">
      {{conname}} :{{value}}
    </div> -->
    <div style="padding:0px 25px; display: flex;flex-wrap: wrap;">
      <div v-for="(v,k) in searchobj" style="margin: 5px 5px;border: solid 1px rgb(99, 97, 97);padding: 0 3px;">
        {{v.name}}:{{v.val}}
        <i  class="weui-icon-clear" @click="delseaobj(k)"></i>
      </div>
    </div>
    <div style="display: flex;position: relative;align-items: center;">
      <van-field readonly @click="jinru" :value="daterili" label="日期区间" placeholder="请选择日期区间" />
      <i class="weui-icon-clear" v-show="daterili" @click="daterili=''" style="position: absolute;right: 5px;"></i>
    </div>




    <div>
      <van-calendar style="display:flex;   
                          width: 100%;min-width: 320px;max-width: 540px;left: 0;right:0;margin:auto;
                          flex-direction: column;
                          align-items: center;
                          " color="#07c160" :min-date="mindate" :max-date="maxDate" @confirm="onConfirm"
        v-model="showrili" type="range" :allow-same-day="true" />
    </div>



    <div style="width: 100%;display: flex;align-items:center;padding:0 10px;box-sizing: border-box;">
      <input type="number" :value="perpage" style="border:solid 1px black;width: 50px;height:30px;text-align: center;"
        placeholder="每页显示" @blur="setperpage($event)">
      <van-pagination v-model="currentPage" :total-items="tempdata.length" :show-page-size="5" force-ellipses
        :items-per-page="perpage" style="width: 100%;" />

    </div>

    <div
      style="display: flex;justify-content: space-around;background-color: white;padding-top: 10px;padding-bottom: 10px;">

      <a @click="allselect">{{result.length==0?'全选':'取消全部'}}</a>
      <a @click="thispageselect">{{flag?'取消本页':"选中本页"}}</a>

      <van-popover v-model="showPopover" trigger="click" :actions="actions" @select="onSelect">
        <template #reference>
          下载选中{{result.length+"条"}}
        </template>
      </van-popover>





    </div>

    <van-checkbox-group v-model="result">
      <div class="weui-cells">
        <a class="weui-cell weui-cell_access" href="javascript:;" v-for="(v,k) in tempdata"
          v-if="k<currentPage*perpage&&k>=(currentPage-1)*perpage">
          <div class="weui-cell__bd" style="padding-top: 0;padding-bottom: 0px;">
            <div @click.stop>
              <van-checkbox shape="square" :name="v.id"></van-checkbox>
            </div>


            <div @click="$router.replace({path:'/getdatadetail',query:{hi:fenye.totalitems-k,id:v.id}})"
              style="margin-left: 15px;flex:1;padding: 15px 0px;">
              <font v-show="gailaninfo[0].check" style="width: 15px;color:blue;font-size:18px">{{gethi(v.id)}}</font>
              <font v-show="gailaninfo[1].check">{{v.createtime.split(' ')[0]}}</font>

              <font style="color: red;" v-show="gailaninfo[2].check">{{v.mystate?v.mystate:""}}</font>
              {{showgailan(v)}}
            </div>
          </div>
          <div class="weui-cell__ft">
          </div>
          <div>&nbsp;&nbsp;</div>
        </a>

      </div>


    </van-checkbox-group>


    <div style="height: 100px;"></div>
  </div>
</template>

<script>
  import { instance } from '@/js/axios.js'
  import Vue from 'vue';
  import { Search } from 'vant';
  Vue.use(Search);
  import { Checkbox, CheckboxGroup } from 'vant';
  import { Popover } from 'vant';
  import { Field } from 'vant';
  Vue.use(Field);
  Vue.use(Popover);

  Vue.use(Checkbox);
  Vue.use(CheckboxGroup);
  import { DropdownMenu, DropdownItem, Cell, Switch } from 'vant';
  import { Button } from 'vant';

  Vue.use(Button);
  Vue.use(DropdownMenu);
  Vue.use(DropdownItem);
  Vue.use(Cell);
  Vue.use(Switch);
  import { Pagination } from 'vant';
  import { Calendar } from 'vant';
  Vue.use(Calendar);
  Vue.use(Pagination);
  import axios from '@/js/axios.js'
  export default {
    name: 'GetData',
    components: {},
    directives: {},

    data() {
      return {
        searchobj:[],
        showall: true,
        percount: 1000,
        allcount: 0,
        showrili: false,
        daterili: '',
        mindate: new Date(2021, 8, 1),
        maxDate: new Date(),
        gailaninfo: [{ name: "编号", check: true }, { name: "创建时间", check: true }, { name: "状态标注", check: true }],
        currentPage: 1,
        fenye: { totalitems: 0 },
        datas: [],
        conname: "",
        value: '',
        perpage: 20,
        value22: '',
        value1: 0,
        bzarr: [],
        xzarr: [],
        value2: 'desc',
        option1: [
          { text: '按姓名', value: 0 },
          { text: '按手机', value: 1 },

        ],
        option2: [
          { text: '最新提交优先', value: 'desc' },
          { text: '最旧提交优先', value: 'asc' },
        ],

        result: [],
        showPopover: false,
        // 通过 actions 属性来定义菜单选项
        actions: [{ text: '下载excel' }, { text: '下载word' }],
      };
    },
    created() {

    },
    computed: {
      tempdata() {
        let data2 = this.datas
          .filter(item => this.haoba(item))
          .filter(item => this.searchcom(item))
          .filter(item => this.clbzarr(item))
        data2.sort((a, b) => this.value2 == "desc" ? (b.id - a.id) : (a.id - b.id))
        this.currentPage = 1;
        return data2;
      },
      flag() {
        let res = this.tempdata.filter((item, index) => {
          let start = (this.currentPage - 1) * this.perpage;
          let end = this.currentPage * this.perpage;
          if (index < end && index >= start) {
            return true;
          }
        }).map(item => item.id);

        return res.some(item => this.result.includes(item));

      }
    },
    watch: {

    },
    methods: {
      delseaobj(k){
        this.searchobj.splice(k,1);
      },
  showalldatas() {
        this.showall = true;
        this.xsall();
      },
      setperpage(e) {
        let page = parseInt(e.target.value);
        if (page > 0) {
          this.perpage = page;
        }
      },
      gethi(v) {
        return this.datas.findIndex(item => item.id == v) + 1;
      },
      clbzarr(item) {
        if (this.xzarr.length < 1) {
          return true;
        }
        //  if(this.xzarr.includes('无状态')){
        //    if(!item.mystate){
        //      return true;
        //    }else{
        //      return false;
        //    }
        //  }   
        let nstate = item.mystate ? item.mystate : '无状态';


        if (this.xzarr.includes(nstate)) {
          return true;
        }
        return false;
      },
      jiaru(v) {
        if (this.xzarr.includes(v)) {
          this.xzarr.splice(this.xzarr.indexOf(v), 1);
        } else {
          this.xzarr.push(v);
        }
      },
      jinru() {

        this.showrili = true;

      },
      formatDate(date) {
        return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
      },
      onConfirm(date) {

        const [start, end] = date;
        this.showrili = false;
        this.daterili = `${this.formatDate(start)} - ${this.formatDate(end)}`;

        // this.haoba();
      },
      haoba(itemtemp) {
        if (!this.daterili) {
          return true;
        }

        let [start, end] = this.daterili.split('-');
        let arr = start.match(/\d+/g);
        arr = arr.map(item => item < 10 ? (item = '0' + item) : item);
        start = new Date(arr.join('-')).getTime();
        let arrb = end.match(/\d+/g);
        arrb = arrb.map(item => item < 10 ? (item = '0' + item) : item);
        end = new Date(arrb.join('-')).getTime();

        let days = (end - start) / 24 / 3600 / 1000;
        let riliarr = [start];
        for (let i = 1; i <= days; i++) {
          riliarr.push(start + i * 3600 * 1000 * 24);
        }

        let cre = itemtemp.createtime.split(' ')[0];
        cre = new Date(cre).getTime();
        if (riliarr.includes(cre)) {
          return true;
        } else {
          return false
        }


      },
      showgailan(v) {
        let info = v.datajson.map(item => {
          let flag = this.gailaninfo.some(i => item.name == i.name && i.check)
          return flag ? item.val : ""
        }).filter(item => item).join(' ');

        return info;
      },
      writelocal(v) {
        v.check = !v.check;
        localStorage.setItem('gailaninfo', JSON.stringify(this.gailaninfo));

      },
      searchcom(item) {
        if(this.searchobj.length==0){
          return true;
        }else{
        return  this.searchobj.every(i=>{
          return  item.datajson.find(item=>(item.name==i.name)&&(item.val.includes(i.val)));
          })

        }


        return;
        // if (!this.value) {
        //   return true;
        // } else {
        //   let xx = item.datajson.find(item => item['name'] == this.conname)
        //   if (!xx) {
        //     return false
        //   }
        //   let yy = xx['val'].includes(this.value);
        //   return yy;

        // }

      },
      onSearch() {
        if(!this.value22){
          return weui.alert("请先输入")
        }

        // this.value = this.value22;
        // this.conname = this.option1.find(item => item.value == this.value1).text.substr(1);
        this.searchobj.push({name:this.option1.find(item => item.value == this.value1).text.substr(1),val:this.value22})
        this.value22 = "";
      },
      onSelect(action) {

        if (!this.result.length) return weui.alert('没有选中的数据');

        if (action.text === "下载excel") {
          this.download();
        }
        if (action.text === "下载word") {
          this.downloadword();
        }


      },
      allselect() {
        if (this.result.length !== 0) {
          this.result = [];
          return;
        }
        this.result = this.tempdata.map(item => item.id);
      },
      thispageselect() {


        let starr = this.tempdata.filter((item, index) => {
          let start = (this.currentPage - 1) * this.perpage;
          let end = this.currentPage * this.perpage;
          if (index < end && index >= start) {
            return true;
          }
        }).map(item => item.id);

        if (!this.flag) {
          this.result = [...this.result, ...starr];
          let ret = Array.from(new Set(this.result));
          this.result = ret;
        } else {
          this.result = this.result.filter(item => !starr.includes(item)
          )
        }
        return;


      },
      download() {
        if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
          return weui.alert('请用电脑下载');
        }


        var loading = weui.loading('正在生成..');
        instance.post('/downloads/qdexcel', { data: this.result }).then(res => {
          loading.hide();
          //这里res.data是返回的blob对象   
          var blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }); //application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
          var downloadElement = document.createElement('a');
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;

          downloadElement.download = '详情信息' + new Date().getTime() + '.xlsx'; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        }).catch(res => {
          console.log(res);
        })


      },
      downloadword() {



        if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {

          return weui.alert('请用电脑下载');
        }

        var loading = weui.loading('正在生成..');
        instance.post('/downloads/qdew', { data: this.result }).then(res => {
          loading.hide();

          //这里res.data是返回的blob对象 
          var blob = new Blob([res.data], { type: 'application/msword;charset=utf-8' }); //application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
          var downloadElement = document.createElement('a');
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;

          downloadElement.download = '编号详细信息.docx'; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
      },
      xsall() {
        axios.post('/zzhpower/qdgetalldata', { order: this.value2 }).then(res => {
          if(res.code==200){
            this.datas = res.data;

            this.allcount = this.datas.length;

          let num = 0;
          for (let i in this.datas) {
            num++;
          }
          this.fenye.totalitems = num;
          this.result = [];

          let nums = 0;
          if (res.mulu.length == 0) return;

          this.gailaninfo = res.mulu.map(item => {
            return { name: item, check: false }
          })
          this.gailaninfo.unshift({ name: '状态标注', check: false })
          this.gailaninfo.unshift({ name: '创建时间', check: true })
          this.gailaninfo.unshift({ name: '编号', check: true })
          let glif = JSON.parse(localStorage.getItem('gailaninfo'));


          if (glif) {

            this.gailaninfo.forEach(item => {
              glif.forEach(i => i.name == item.name ? item.check = i.check : "")
            })


          }
         let newres = res.mulu.map(item => {
            return { text: '按' + item, value: nums++ };
          })
          this.option1 = newres;

          
          }


        });

      },



    },
    mounted() {

    },
    activated() {
      this.xsall()




    }

  };
</script>

<style lang="less">
  .pastate {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
  }

  .state {
    margin-bottom: 8px;
    width: 90px;
    border: solid 1px black;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .xzstate {
    background-color: #b1aeae;
    color: white;
    margin-bottom: 8px;
    width: 90px;
    border: solid 1px black;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .testate {
    color: rgb(13, 129, 123);
    margin-bottom: 8px;
    width: 90px;
    border: solid 1px rgb(13, 129, 123);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .zxtestate {
    color: white;
    background-color: rgb(13, 129, 123);
    margin-bottom: 8px;
    width: 90px;
    border: solid 1px rgb(13, 129, 123);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .statetemp {
    margin-bottom: 8px;
    width: 90px;

    display: flex;
    justify-content: center;
    align-items: center;
  }


  .van-dropdown-item {
    min-width: 320px;
    max-width: 540px;
    left: 0;
    right: 0;
    margin: auto;
  }

  .acss:active {
    background-color: rgb(141, 131, 131);
    color: white;
  }
</style>


// WEBPACK FOOTER //
// src/manage/GetData.vue